export const COLORS = {
    black: '#000000',
    white: '#FFFFFF',
    darkGray: '#5E6669',
    coolGray: '#A5A8AA',
    lightGray: '#E8E9EA',
    UISBlue: '#003366',
    UIUCBlue: '#13294b',
    UIUCBlue2: '#0455A4',
    UIUCBlue3: '#1F4096',
    UIUCOrange: '#FF5F0F',
    JDYellow: '#FFDE00',
    JDBlack: '#27251F',
    JDGreen: '#367C2B',
    CargillGreen: '#008544',
    UlineBlue: '#036',
    UlineRed: '#c00'
  };
  